import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from '../../components/loading/loading.component';
import { AsyncPipe } from '@angular/common';
import { LoadingService } from '../../../core/services/loading/loading.service';

@Component({
    selector: 'app-simple-layout',
    templateUrl: './simple-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FooterComponent,
        HeaderComponent,
        RouterModule,
        LoadingComponent,
        AsyncPipe,
    ],
})
export class SimpleLayoutComponent {
    loading$ = this.loadingService.loading$;

    constructor(private readonly loadingService: LoadingService) {}
}
